require('../../../modules/es.array.filter');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').filter;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/array/virtual/filter.js
// module id = 973
// module chunks = 0